import { useState, useEffect } from 'react';

const ImageGallery = ({ urls = [], width = "w-full", height = "h-96" }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  
  // Early return if no images
  if (!urls.length) {
    return (
      <div className={`${width} ${height} bg-gray-200 flex items-center justify-center`}>
        <p className="text-gray-500">No images to display</p>
      </div>
    );
  }

  // Calculate the width of each hover area
  const hoverAreaWidth = 100 / urls.length;
  
  return (
    <div className="flex flex-col items-center">
      {/* Container for images and hover areas */}
      <div className={`relative ${width} ${height} overflow-hidden`}>
        {/* Render all images, only the active one visible */}
        {urls.map((url, index) => (
          <div 
            key={`img-${index}`}
            className={`absolute inset-0 transition-opacity duration-300 ${index === activeIndex ? 'opacity-100' : 'opacity-0'}`}
          >
            <img 
              src={url} 
              alt={`Gallery image ${index + 1}`} 
              className={`${width} ${height} object-cover`}
            />
          </div>
        ))}
        
        {/* Hover areas */}
        <div className="absolute inset-0 flex">
          {urls.map((_, index) => (
            <div
              key={`hover-${index}`}
              className="h-full cursor-pointer"
              style={{ width: `${hoverAreaWidth}%` }}
              onMouseEnter={() => setActiveIndex(index)}
            />
          ))}
        </div>
      </div>
      
      {/* Pagination dots */}
      <div className="flex gap-2 mt-4">
        {urls.map((_, index) => (
          <button
            key={`dot-${index}`}
            className={`w-3 h-3 rounded-full transition-colors ${
              index === activeIndex ? 'bg-black' : 'bg-gray-300'
            }`}
            onClick={() => setActiveIndex(index)}
            aria-label={`View image ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;